import React from "react";
import { AdSlot } from "../../components/ads/AdSlot";
import SmiWidget from "../../components/smiWidgets/SmiWidget";

export const PopupModal = ({ show, onClose, isFull, isDesktop, widgetBlocks }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <span className="close-modal-button" onClick={onClose}>
                    &times;
                </span>
                <AdSlot
                    slot="popupmodal"
                    isFull={isFull}
                    isDesktop={isDesktop}
                    fallback={<SmiWidget isDesktop={isDesktop} isFull={isFull} blockIds={widgetBlocks.popupModal} />}
                />
            </div>
        </div>
    );
};
